import flagKeys from '@/constants/flagKeys';
import RewardedCoins from '@/views/Transactions/RewardedCoins.vue';
import { Route } from '../route.model';

const rewardedCoins = new Route(
  '/transactions/coins/rewarded',
  'transaction_coins_rewarded',
  RewardedCoins,
  {
    requiresAuth: true,
    flag: flagKeys.legacyReports,
    isResponsive: flagKeys.responsiveDashboard,
    zendesk: {
      mobile: {
        offsetHorizontal: '4px',
        offsetVertical: '4px'
      }
    },
    navbar: {
      name: 'Rewarded Coins', // TODO apply i18n
      icon: 'coin-rewarded'
    }
  }
);

export { rewardedCoins };
export default rewardedCoins;
